// extracted by mini-css-extract-plugin
export default {"wrapper":"selector_wrapper__aoR5A","active":"selector_active__4JsH7","left":"selector_left__qHPQh","right":"selector_right__pDT0h"};